<template>
  <div class="group grid size-4 grid-cols-1">
    <input
      ref="checkboxRef"
      type="checkbox"
      class="checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline-primary col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
      :checked="modelValue"
      :disabled="disabled"
      @change="onChange"
    />
    <svg
      class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        class="opacity-0 group-has-[:checked]:opacity-100"
        d="M3 8L6 11L11 3.5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        class="opacity-0 group-has-[:indeterminate]:opacity-100"
        d="M3 7H11"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    indeterminate?: boolean;
    disabled?: boolean;
  }>(),
  { indeterminate: false, disabled: false },
);

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
}>();

const checkboxRef = ref<HTMLInputElement | null>(null);

watchEffect(() => {
  if (checkboxRef.value) {
    checkboxRef.value.indeterminate = !!props.indeterminate;
  }
});

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit("update:modelValue", !!target.checked);
};
</script>
